export const MENSAGEM_CIDADAO_FORA_AREA = 'Cidadão fora de área'
export const FORA_AREA = 'FA'
export const MSG_DADO_RECEBIDO_CADSUS = 'Dado recebido da base nacional. Não pode ser editado.'
const MSG_BASE_RESPONSAVEL = 'informado não pode pertencer ao próprio cidadão cadastrado.'
export const MSG_CPF_RESPONSAVEL_FAMILIAR_IGUAL_CIDADAO = 'CPF ' + MSG_BASE_RESPONSAVEL
export const MSG_CNS_RESPONSAVEL_FAMILIAR_IGUAL_CIDADAO = 'CNS ' + MSG_BASE_RESPONSAVEL
export const MSG_RESPONSAVEL_PRECISA_DE_CPF_OU_CNS = 'É obrigatório possuir CPF ou CNS para ser responsável familiar'
export const CODIGO_PAIS_BRASIL = '31'
